import PackageDetail from '../containers/PackageDetail';
import { SourceType } from '../modules/generated/api';

import ActionDetailLink from './ActionDetailLink';
import { BidsTableNextItem } from './cars-table-next/types';
import DetailDialog from './DetailDialog';

type PackageDetailDialogProps = {
  packageBid?: BidsTableNextItem;
  index?: number;
  maxItems: number;
  moveToNext?: () => void;
  moveToPrev?: () => void;
  onClose: () => void;
};

const PackageDetailDialog = ({
  packageBid,
  index,
  maxItems,
  moveToNext,
  moveToPrev,
  onClose,
}: PackageDetailDialogProps) => {
  const { packageAggregation, source: carSource } = packageBid || {};
  const packageId = packageBid?.packageId ?? packageAggregation?.packageId;
  const source = carSource ?? packageAggregation?.source;

  return (
    <DetailDialog
      open={!!packageBid}
      index={index}
      maxItems={maxItems}
      moveToNext={moveToNext}
      moveToPrev={moveToPrev}
      onClose={onClose}
      actionsTopRight={
        <ActionDetailLink
          key="detail-link"
          href={source && packageId ? `/cars/${source}/package/${packageId}` : ''}
          disabled={!source || !packageId}
          tooltipPosition="left"
        />
      }
    >
      {source && packageId && <PackageDetail source={source as SourceType} packageId={packageId} />}
    </DetailDialog>
  );
};

export default PackageDetailDialog;
